import * as AC from './actionTypes';

export const getAdmins = (filters = {}) => ({
  type: AC.GET_ADMINS_REQUEST,
  filters,
});

export const getAdminById = id => ({
  type: AC.GET_ADMIN_DETAILS_REQUEST,
  id,
});

export const addAdmin = (
  email,
  firstName,
  lastName,
  phoneNumber,
  address,
  birthday,
  signatureUrl,
  buildingIds,
) => ({
  type: AC.ADD_ADMIN_REQUEST,
  payload: {
    email,
    firstName,
    lastName,
    phoneNumber,
    address,
    birthday,
    signatureUrl,
    buildingIds,
  },
});

export const editAdmin = (
  email,
  firstName,
  lastName,
  phoneNumber,
  address,
  birthday,
  signatureUrl,
  buildingIds,
  id,
) => ({
  type: AC.EDIT_ADMIN_REQUEST,
  payload: {
    email,
    firstName,
    lastName,
    phoneNumber,
    address,
    birthday,
    signatureUrl,
    buildingIds,
    id,
  },
});

export const deleteAdmin = id => ({
  type: AC.DELETE_ADMIN_REQUEST,
  id,
});
